import { Download } from '@mui/icons-material'
import { GridActionsCellItem } from '@mui/x-data-grid'
import { useRef, useState } from 'react'
import { DownloadMenu } from '@/features/search/SearchResults/actions/DownloadMenu'
import type { FileAttachment } from '@/features/search/types'

type Props = {
  files: FileAttachment[]
  mediaCode: number
}

export const DownloadAction = (props: Props) => {
  const ref = useRef(null)
  const [open, setOpen] = useState(false)
  const handleClose = () => setOpen(false)

  return (
    <>
      <GridActionsCellItem
        ref={ref}
        key="download"
        icon={<Download />}
        label="Download"
        title="Download"
        onClick={() => {
          setOpen(true)
        }}
      />
      <DownloadMenu
        open={open}
        onClose={handleClose}
        anchorEl={ref.current}
        mediaCode={props.mediaCode}
        files={props.files}
      />
    </>
  )
}
